import type { Duration } from 'date-fns'

/**
 * Converts a date-fns Duration object to use absolute values
 * @param duration The duration object to process
 * @returns A new Duration object with absolute values
 */
export const absoluteDuration = (duration: Duration): Duration => {
  return Object.fromEntries(
    Object.entries(duration).map(([key, value]) => [key, Math.abs(value ?? 0)])
  ) as Duration
}
